export enum LabelSize {
  Small = "text-sm",
  Normal = "text-base",
  Large = "text-lg",
}
